import { useQuery } from "@tanstack/react-query";
import { api, API, TOKEN_KEY } from "@/lib/api";

export function useTeamMap() {
  const { data = [] } = useQuery({ queryKey: ["team-avatars"], queryFn: () => api.get("/team", { params: { all: true } }).then((r) => r.data), staleTime: 120000 });
  const byId = Object.fromEntries(data.map((m) => [m.id, m]));
  const byName = Object.fromEntries(data.map((m) => [m.name, m]));
  return { byId, byName };
}

export function Avatar({ user, size = 36, testId = "avatar", className = "" }) {
  const initials = (user?.name || "?").split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();
  const style = { width: size, height: size };
  if (user?.avatar_file_id) {
    return <img src={`${API}/files/${user.avatar_file_id}?auth=${localStorage.getItem(TOKEN_KEY) || ""}`} alt={user.name} style={style} className={`shrink-0 rounded-full border-2 border-black object-cover ${className}`} data-testid={testId} />;
  }
  return (
    <span style={{ ...style, fontSize: size * 0.38 }} className={`inline-flex shrink-0 items-center justify-center rounded-full border-2 border-black bg-[#FACC15] font-display font-extrabold ${className}`} data-testid={testId}>{initials}</span>
  );
}

export function NameWithAvatar({ id, name, size = 24, children, testId }) {
  const { byId, byName } = useTeamMap();
  const member = (id && byId[id]) || byName[name] || { name };
  return (
    <span className="inline-flex items-center gap-2" data-testid={testId}>
      <Avatar user={member} size={size} testId={`${testId || "avatar"}-img`} />
      <span>{children ?? name}</span>
    </span>
  );
}
